export default __webpack_public_path__ + "static/media/NOTO_SANS_SC_600.a455ee6b.ttf";